<template>
    <div style="height: 100%;">
        <div class="top-box">
            <div>
                <el-button @click="addCatalog" :class="{ 'disabled-btn': disabled }" v-if="this.tableData.length == 0">
                    <div style="display: flex;align-items: center;">
                        <i class="iconfont icon-jiahao"></i>
                        <p style="color: #334681;">初始化章节目录</p>
                    </div>
                </el-button>
                <el-button @click="addOutLayer" :class="{ 'disabled-btn': disabled }" v-if="this.tableData.length > 0">
                    <p style="color: #334681;">新增章节</p>
                </el-button>
                <el-button @click="mostDel" :class="{ 'disabled-btn': disabled }" v-if="this.tableData.length > 0">
                    <p style="color: #334681;" @click="mostDel">批量删除</p>
                </el-button>
            </div>
            <div>
                <div style="margin-right: 1rem;cursor: pointer;">搜索</div>
                <el-input v-model="pages.keyword" placeholder="请输入内容">
                    <template slot="prefix">
                        <div style="height: 100%;display: flex;align-items: center;">
                            <i class="iconfont icon-Magnifier"></i>
                        </div>
                    </template>
                </el-input>
            </div>
        </div>
        <div style="margin-top: 2rem;height: calc(100% - 3.5rem);">
            <Table :totalSize="tableTotal" :pagination="false" :serialNumber="true" :sequenceNumber="false"
                :operationWidth="350" :currentPage="pages.current" @SelectEvent="selectEvent" :pageSize="pages.size"
                navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                <template slot="name" slot-scope="data">
                    <div v-if="!data.data.row.flag">{{ data.data.row.name }}</div>
                    <el-input v-else placeholder="请输入" style="width: 30rem;" @blur="changeStatus(data.data.row)"
                        v-model="data.data.row.name"></el-input>
                </template>
                <!-- <template slot="sort">
                    <el-button class="drag-handle" icon="el-icon-rank"></el-button>
                </template> -->
                <template slot="operation" slot-scope="data">
                    <div class="operation-box" v-if="!data.data.row.adding">
                        <el-tooltip class="item" effect="dark" content="新增子集" placement="top-start">
                            <i style="font-size: 16px;" class="iconfont icon-xinzengziji"
                                :class="{ 'disabled-btn': disabled }" @click="addChild(data.data.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i style="font-size: 16px;" class="iconfont icon-bianji1"
                                :class="{ 'disabled-btn': disabled }" @click="edit(data.data.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i style="font-size: 16px;" class="el-icon-delete" :class="{ 'disabled-btn': disabled }"
                                @click="del(data.data.row)"></i>
                        </el-tooltip>
                    </div>
                    <div class="operation-box-else" v-else>
                        <el-tooltip class="item" effect="dark" content="添加" placement="top-start">
                            <i style="font-size: 16px;" class="iconfont icon-gou"
                                :class="{ 'disabled-btn': disabled }" @click="addChapter(data.data.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i style="font-size: 16px;" class="iconfont icon-guanbi"
                                :class="{ 'disabled-btn': disabled }" @click="delChild(data.data.row)"></i>
                        </el-tooltip>
                    </div>
                </template>
            </Table>
        </div>
        <el-dialog :close-on-click-modal="false" title="添加章节目录" :visible.sync="dialogVisible" width="87rem">
            <div class="tip">（各章节最小子级将自动设为教学单元）</div>
            <div class="dia-content">
                <div>
                    <catalog-tree :treeData="catalogTree" :parentId="-1"></catalog-tree>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="cancel-btn" @click="dialogVisible = false">取消</div>
                <div class="save" v-debounce="save">保存</div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import CatalogTree from './CatalogTree.vue';
import { generateSixDigitUUID } from '@/utils/utils';
import draggable from 'vuedraggable';
import { InitChapterTree, GetChapterTree, UpdateChapter, DelChapter, AddChapter, UpdateChapterOrder } from '@/api/courseChapter';
import Sortable from "sortablejs";
import Utils from '@/assets/js/Utils';
export default {
    props: ['disabled'],
    components: { CatalogTree, draggable },
    data() {
        return {
            tableTotal: 0,
            sortable: null,
            /**列表勾选的数据 */
            selectIds: [],
            /**添加目录弹窗 */
            dialogVisible: false,
            tableData: [],
            /**树结构扁平化处理数据 */
            activeRows: [],
            /**添加目录数据 */
            catalogTree: [
                {
                    "courseId": this.courseId,
                    "icon": "",
                    "id": generateSixDigitUUID(),
                    "name": "",
                    "orderIndex": 1,
                    "parentId": -1
                },
            ],
            tableKey: [
                { name: '章节', value: 'name', slot: 'name' },
                // { name: '排序', value: 'sort', slot: 'sort' },
                { name: '操作', value: 'operation', slot: 'operation' },
            ],
            pages: {
                current: 1,
                size: 10,
                keyword: ''
            },
            sortableFlag: true
        }
    },
    mounted() {
        Utils.$on('del_tree', this.delTree);
        Utils.$on('ai_create_course_selection', this.handleAiData);
    },
    computed: {
        courseId() {
            return this.$store.state.course.currentCourseId || this.$route.query.id || '';
        }
    },
    methods: {
        /**递归处理数据 */
        handleData(data, parentId) {
            data.forEach((item, index) => {
                item.courseId = this.courseId;
                item.icon = '';
                item.id = generateSixDigitUUID();
                item.orderIndex = index + 1;
                item.parentId = parentId || -1;
                if (item.children) {
                    this.handleData(item.children, item.id);
                }
            })
        },
        /**处理ai数据 */
        handleAiData(data) {
            const handleFn=()=>{
                this.handleData(data);
                var treeList = [];
                this.handleChapter(data, treeList);
                InitChapterTree(treeList).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            type: 'success',
                            message: '保存成功!'
                        });
                        this.getChapterTree();
                    }
                })
            }
            if (this.tableData.length > 0) {
                this.$confirm('您已存在章节数据，是否覆盖？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    let ids=[];
                    this.tableData.forEach(item=>{
                        ids.push(item.id,...this.getIds(item.children));
                    })
                    DelChapter({"ids":ids}).then(()=>{
                        handleFn();
                    })
                  });
               return;
            }else{
                handleFn();
                console.log()
            }
        },
        setSort() {
            const el = this.$refs.table.$refs.tempTable.$el.querySelectorAll("tbody")[0];
            this.sortable = Sortable.create(el, {
                handle: '.drag-handle',
                animation: 150,
                setData: function (dataTransfer) {
                    dataTransfer.setData("Text", "");
                },
                onMove: ({ dragged, related }) => {
                    if (this.sortableFlag == false) return false;
                    const oldRow = this.activeRows[dragged.rowIndex] // 移动的那个元素
                    const newRow = this.activeRows[related.rowIndex] // 新的元素
                    if (oldRow.parentId !== newRow.parentId) { // 移动的元素与新元素父级id不相同
                        return false // 不允许跨级拖动
                    }
                },
                onStart: () => { // 开始拖拽前把树形结构数据扁平化
                    this.activeRows = this.treeToTile(this.tableData); // 把树形的结构转为列表再进行拖拽
                },
                onEnd: e => {
                    let exchangeOrder = this.activeRows[e.oldIndex];
                    let order = this.activeRows[e.newIndex];
                    if (exchangeOrder.parentId == order.parentId && exchangeOrder.id != order.id) {
                        this.sortableFlag = false;
                        this.updateChapterOrder(exchangeOrder.id, order.id).then(async () => {
                            await this.getChapterTree();
                            this.sortableFlag = true;
                        });
                    }
                },
            });
        },
        changeStatus(item) {
            if (item.adding) return;
            item.flag = false;
            this.updateChapter(item);
        },
        /**
         * 将树数据转化为平铺数据
         * @param <Array> treeData当前要转的id
         * @param <String> childKey 子级字段
         * @return <Array> 返回数据
         */
        treeToTile(treeData, arr = []) {
            treeData.forEach(item => {
                arr.push(item);
                if (item.children) {
                    this.treeToTile(item.children, arr);
                }
            })
            return arr;
        },
        /**新增章节最外层 */
        addOutLayer() {
            if (this.disabled) return;
            var item = {
                "courseId": this.courseId,
                "icon": "",
                "id": generateSixDigitUUID(),
                "name": "",
                "orderIndex": this.tableData.length + 1,
                "parentId": -1,
                "adding": true,
                "flag": true
            }
            this.tableData.push(item);
        },
        /**新增子集 */
        addChild(data) {
            if (this.disabled) return;
            var item = {
                "courseId": this.courseId,
                "icon": "",
                "id": generateSixDigitUUID(),
                "name": "",
                "orderIndex": data.children ? data.children.length + 1 : 1,
                "parentId": data.id,
                "adding": true,
                "flag": true
            }
            if (data.children) {
                data.children.push(item);
            } else {
                this.$set(data, 'children', [item]);
            }
            this.$nextTick(() => {
                this.$refs.table.$refs.tempTable.toggleRowExpansion(data, true);
            })
        },
        delChild(data) {
            if (this.disabled) return;
            if (data.parentId == -1) {
                var index = this.tableData.findIndex(e => e.id == data.id);
                this.tableData.splice(index, 1);
                return;
            }
            var parent = this.getParentIds(this.tableData, data.parentId);
            if (parent) {
                var index = parent.children.findIndex(e => e.id == data.id);
                parent.children.splice(index, 1);
            }
        },
        /**查找包含父节点id */
        getParentIds(data, id) {
            for (var item of data) {
                if (item.id == id) {
                    return item;
                } else {
                    if (item.children && item.children.length > 0) {
                        var d = this.getParentIds(item.children, id);
                        if (d) {
                            return d;
                        }
                    }
                }
            }
        },
        /**编辑 */
        edit(data) {
            if (this.disabled) return;
            data.flag = true;
        },
        /**勾选列表数据 */
        selectEvent(e) {
            e = this.handleFlatData(e);
            this.selectIds = e;
        },
        /**扁平化处理数据 */
        handleFlatData(data, arr = []) {
            data.forEach(item => {
                arr.push(item);
                if (item.children) {
                    this.handleFlatData(item.children, arr);
                }
            })
            return arr;
        },
        /**新增章节 */
        addChapter(data) {
            if (this.disabled) return;
            var params = {
                "courseId": this.courseId,
                "icon": "",
                "id": data.id,
                "name": data.name,
                "orderIndex": data.orderIndex,
                "parentId": data.parentId
            }
            AddChapter(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "新增章节成功",
                        type: "success",
                    });
                    this.getChapterTree();
                }
            })
        },
        /**修改课程教学单元信息 */
        updateChapter(data, callback) {
            UpdateChapter(data).then(res => {
                if (res.code == 200) {
                    typeof callback == 'function' && callback();
                } else {
                    this.getChapterTree();
                }
            }).catch(() => {
                this.getChapterTree();
            });
        },
        /**修改章节排序 */
        updateChapterOrder(exchangeOrderId, id) {
            return new Promise(resolve => {
                let params = {
                    "exchangeOrderId": exchangeOrderId,
                    "id": id
                }
                UpdateChapterOrder(params).then(res => {
                    if (res.code == 200) {
                        resolve();
                    }
                });
            })
        },
        /**批量删除课程章节信息 */
        delChapter(data) {
            var params = {
                ids: data
            }
            DelChapter(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "删除成功",
                        type: "success",
                    });
                    this.getChapterTree();
                }
            })
        },
        /**批量编辑 */
        mostEdit() {
            if (this.selectIds.length == 0) {
                this.$msg({
                    showClose: true,
                    message: "请先勾选数据",
                    type: "warning",
                });
                return;
            }
        },
        /**批量删除 */
        mostDel() {
            if (this.disabled) return;
            if (this.selectIds.length == 0) {
                this.$msg({
                    showClose: true,
                    message: "请先勾选数据",
                    type: "warning",
                });
                return;
            }
            var data = this.selectIds.map(item => item.id);
            this.delChapter(data);
        },
        /**删除 */
        del(data) {
            if (this.disabled) return;
            var ids = [data.id];
            if (data.children || data.children.length > 0) {
                this.getIds(data.children, ids);
            }
            this.delChapter(ids);
        },
        /**获取父节点在内的所有子节点的id */
        getIds(data, ids = []) {
            data.forEach(item => {
                ids.push(item.id);
                if (item.children && item.children.length > 0) {
                    this.getIds(item.children, ids);
                }
            })
            return ids;
        },
        /**新增章节目录 */
        addCatalog() {
            if (this.disabled) return;
            if (this.tableData.length == 0) {
                this.catalogTree = [
                    {
                        "courseId": this.courseId,
                        "icon": "",
                        "id": generateSixDigitUUID(),
                        "name": "",
                        "orderIndex": 1,
                        "parentId": -1
                    },
                ]
            }
            this.dialogVisible = true;
        },
        /**取消 */
        cancel() {
            this.dialogVisible = false;
        },
        /**递归处理章节树 */
        handleChapter(data, arr = []) {
            data.forEach(item => {
                arr.push(item);
                if (item.children && item.children.length > 0) {
                    this.handleChapter(item.children, arr);
                }
            })
            return arr;
        },
        /**递归给树添加flag字段 */
        handleTree(data) {
            data.forEach(item => {
                item.flag = false;
                if (item.children && item.children.length > 0) {
                    this.handleTree(item.children);
                }
            })
        },
        /**课程章节信息查询 */
        getChapterTree() {
            return new Promise(resolve => {
                var params = {
                    "courseId": this.courseId,
                };
                GetChapterTree(params).then(res => {
                    if (res.code == 200) {
                        this.handleTree(res.data);
                        this.tableData = res.data;
                        this.$nextTick(() => {
                            // if (!this.sortable) {
                            //     this.setSort();
                            // }
                            resolve();
                        })
                    }
                })
            })
        },
        /**保存 */
        save() {
            var treeList = [];
            this.handleChapter(this.catalogTree, treeList);
            InitChapterTree(treeList).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        type: 'success',
                        message: '保存成功!'
                    });
                    this.getChapterTree();
                    this.dialogVisible = false;
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
.icon-jiahao {
    color: var(--blue);
    margin-right: 3px;
    font-size: 16px;
}

.top-box {
    display: flex;
    justify-content: space-between;

    &> :nth-child(2) {
        display: flex;
        align-items: center;
    }
}

.icon-Magnifier {
    color: #CFD5D9;
    font-weight: 600;
}

/deep/.el-input__inner {
    border-radius: 1rem;
}

/deep/.cell {
    white-space: nowrap;
}

.operation-box {
    color: var(--blue);
    display: flex;
    align-items: center;

    &> :nth-child(2) {
        margin-left: 1rem;
    }

    &> :nth-child(3) {
        margin-left: 1rem;
        font-size: 1.8rem;
    }

    &> :nth-child(n) {
        cursor: pointer;
    }
}

/deep/.el-dialog {
    border-radius: 10px;
    box-shadow: 0px 0px 15px 0px rgba(231, 236, 239, 0.10);
}

/deep/.el-dialog__header {
    text-align: center;
}

.tip {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #8590b3;
    position: absolute;
    top: 5rem;
    left: 50%;
    transform: translateX(-50%);
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

.dia-content {
    border: 1px solid #e8ecef;
    height: 60rem;
    overflow: auto;
    border-radius: 10px;
    padding: 2rem;
}

/deep/.cell {
    display: flex;
}

.operation-box-else {
    display: flex;
    cursor: pointer;
    font-size: 2rem;

    &> :nth-child(1) {
        color: #67c23a;
        margin-right: 1rem;
    }

    &> :nth-child(2) {
        color: #f56c6c;
    }
}
</style>